import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useProfileReadQuery } from "../store/generated.ts";
import Loader from "./Loader.js";

const isReactSnap =
  typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

const AuthProtectedRoute = ({ redirectPath = "/home" }) => {
  const token =
    !isReactSnap && typeof window !== "undefined"
      ? localStorage.getItem("authToken")
      : null;

  const { isLoading, isSuccess } = useProfileReadQuery(undefined, {
    skip: isReactSnap || !token,
  });

  if (isReactSnap) {
    return <Outlet />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (isSuccess) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default AuthProtectedRoute;
